/**
 * FeaturesTab — iter86.29 · Canon → Features (the product canon).
 * iter86.58 — the read-only vendor registry mirror card was removed;
 * vendor names on each feature row now jump straight to the Vendor
 * Registry (Mezzanine → Vendors) via onJumpToVendor.
 */
import { BookOpenCheck } from "lucide-react";
import FeatureCatalogCard from "@/components/site-admin/FeatureCatalogCard";

export default function FeaturesTab({ onJumpToVendor }) {
    return (
        <div className="space-y-4" data-testid="features-tab">
            <div className="brutal-card p-4 border-2 border-fuchsia-900/40 bg-fuchsia-950/10">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                    <BookOpenCheck className="w-4 h-4 text-fuchsia-300" />
                    <h2 className="font-display font-extrabold text-lg uppercase tracking-wide text-white">
                        Features — Product Canon
                    </h2>
                    <span className="pill text-[9px] font-bold uppercase border bg-fuchsia-900/40 text-fuchsia-200 border-fuchsia-700">
                        Registry
                    </span>
                </div>
                <p className="text-xs text-zinc-400">
                    The canonical feature catalog — what the product is, mapped to standards, vendors, and docs.
                    Source of truth: <code>feature_registry.md</code> (edit via PR). Vendor names on each row link
                    to the Vendor Registry (Mezzanine → Vendors).
                </p>
            </div>

            <FeatureCatalogCard defaultOpen onJumpToVendor={onJumpToVendor} />
        </div>
    );
}
